<!-- 装车数据操作 -->
<template>
	<div>
		<div v-if="isLoaded">
			<div class="demo-drawer__content data_action_form">
				<div class="page_title">
					<el-alert :title="dataActionBox.boxTitle" type="success" effect="dark" :closable="false"></el-alert>
				</div>
				<el-tabs type="border-card" v-model="showTabs" class="el-tabs--border-card_new">
					<el-tab-pane v-for="(formListValue,formKey) in formDataList" :key="formKey"
						:label="formListValue.jciName" :name="formListValue.jciName" v-if="formListValue.isShowForm!=1">
						<div class="table_content_box">
							<!-- 主要信息 -->
							<div v-if="formKey == 0">
								<el-form label-width="150px" class="baseForm"
									:model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
									<el-row  v-if="dataActionBox.actionType != 2" ref="allRow">
										<el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1"
											v-for="(formOneValue,formOneKey) in formListValue.jurconfigform"
											:key="formOneKey" :prop="formOneValue.entityField"
											:rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []">
											<df-date v-if="formOneValue.entityField == 'psomBuydate'"
												v-model="sendDataInfo[formOneValue.entityField]"
												:isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" />
											<!-- 已记账销售订单id -->
											<el-radio-group v-else-if="formOneValue.entityField == 'isCold'"
												v-model="sendDataInfo.isCold" size="mini"
												:disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
												@change="changeOrder">
												<el-radio-button :label="0">普通</el-radio-button>
												<el-radio-button :label="1">冷链</el-radio-button>
											</el-radio-group>
											<el-radio-group v-else-if="formOneValue.entityField == 'isTripartite'"
												v-model="sendDataInfo.isTripartite" size="mini"
												:disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
												<el-radio-button :label="0">自配</el-radio-button>
												<el-radio-button :label="1">物流</el-radio-button>
											</el-radio-group>
											<!-- <el-input v-else-if="formOneValue.fieldType == 'search' && sendDataInfo.isTripartite == 0" clearable
												v-model="sendDataInfo[formOneValue.entityField]"
												:ref="formOneValue.entityField" :id="formOneValue.entityField"
												@keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
												:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1">
												<el-button
													@click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
													slot="append" icon="el-icon-search"
													:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1">
												</el-button>
											</el-input> -->
											<el-input v-else-if="formOneValue.entityField == 'vmLicensecode'" clearable
												v-model="sendDataInfo[formOneValue.entityField]"
												:ref="formOneValue.entityField" :id="formOneValue.entityField"
												@keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
												:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1 || sendDataInfo.isTripartite == 1">
												<el-button
													@click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
													slot="append" icon="el-icon-search"
													:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1 || sendDataInfo.isTripartite == 1">
												</el-button>
											</el-input>
											<el-input v-else-if="formOneValue.entityField == 'deliveryName'" clearable
												v-model="sendDataInfo[formOneValue.entityField]"
												:ref="formOneValue.entityField" :id="formOneValue.entityField"
												@keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
												:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1 || sendDataInfo.isTripartite == 1">
												<el-button
													@click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
													slot="append" icon="el-icon-search"
													:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1 || sendDataInfo.isTripartite == 1">
												</el-button>
											</el-input>
											<el-input v-else-if="formOneValue.entityField == 'driverName'" clearable
												v-model="sendDataInfo[formOneValue.entityField]"
												:ref="formOneValue.entityField" :id="formOneValue.entityField"
												@keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
												:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1 || sendDataInfo.isTripartite == 1">
												<el-button
													@click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
													slot="append" icon="el-icon-search"
													:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1  || sendDataInfo.isTripartite == 1">
												</el-button>
											</el-input>
											<el-input v-else-if="formOneValue.entityField == 'loName'" clearable
												v-model="sendDataInfo[formOneValue.entityField]"
												:ref="formOneValue.entityField" :id="formOneValue.entityField"
												@keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
												:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1  || sendDataInfo.isTripartite == 0">
												<el-button
													@click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
													slot="append" icon="el-icon-search"
													:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1  || sendDataInfo.isTripartite == 0">
												</el-button>
											</el-input>
											<el-input v-else-if="formOneValue.entityField == 'logisticsNum'" clearable
												:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 2  || sendDataInfo.isTripartite == 0"
												v-model.trim="sendDataInfo[formOneValue.entityField]"
												:maxlength="$store.state.inputLength">
											</el-input>
											<el-input v-else-if="formOneValue.entityField == 'logisticsMoney'" clearable
												type="number"
												:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 2  || sendDataInfo.isTripartite == 0"
												v-model.trim="sendDataInfo[formOneValue.entityField]"
												:maxlength="$store.state.inputLength">
											</el-input>
											<el-input v-else clearable
												:disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 2"
												v-model.trim="sendDataInfo[formOneValue.entityField]"
												:maxlength="$store.state.inputLength">
											</el-input>
										</el-form-item>
									</el-row>
									<el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in formListValue.jurconfigform" :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                          sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                       {{ $common.getIsGsp(formOneValue.formatterContent, sendDataInfo[formOneValue.entityField]) }}
                                    </span>
                                    <span v-else-if="formOneValue.entityField == 'isCold' ">{{ sendDataInfo[formOneValue.entityField]
                          == 0 ? "普通" : "冷链" }}</span>
                                    <span v-else-if="formOneValue.entityField == 'movmOutstid'">{{ sendDataInfo['movmOutstName'] }}</span>
                                    <span v-else-if="formOneValue.entityField == 'movmInstid'">{{ sendDataInfo['movmInstName'] }}</span>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
								</el-form>

								<!-- 默认显示 -->
								<el-form :inline="true" size="mini">
									<div style="margin-bottom: 0.5rem;" v-if="dataActionBox.actionType != 2">
										<el-button type="primary" size="mini" @click="extract('sendDataInfo')">提取
										</el-button>
									</div>
									<!-- 普通 -->
									<el-table :data="mainData" :height="mxHeight" size="mini" border style="width: 100%"
										v-if="isShowDetail==false">
										<el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
											<template slot-scope="scope">
												<el-radio v-model="selectedDataIndex" :label="scope.$index" border
													size="mini">
													<i class="el-icon-thumb"></i>
												</el-radio>
											</template>
										</el-table-column>
										<el-table-column
											v-for="(formOneValue,formOneKey) in formDataList[1].jurconfigform"
											:min-width="formOneValue.fieldWeight" :prop="formOneValue.entityField"
											show-overflow-tooltip :label="formOneValue.showField" :key="formOneKey"
											v-if="formOneValue.isShow==1">
											<template slot-scope="scope">
												<span v-if="formOneValue.fieldType == 'date'">
													<span v-if="scope.row[formOneValue.entityField]">
														{{$common.getLocalTime(scope.row[formOneValue.entityField])}}
													</span>
												</span>
												<span v-else-if="formOneValue.entityField == 'accountTime'">
													<span v-if="scope.row[formOneValue.entityField]">
														{{$common.getLocalTime(scope.row[formOneValue.entityField])}}
													</span>
												</span>
												<el-tag size="mini"
													v-else-if="formOneValue.entityField == 'wobkemState'">
													{{$common.getIsGsp(formOneValue.formatterContent,scope.row.wobkemState)}}
												</el-tag>
												<el-tag size="mini" v-else-if="formOneValue.entityField == 'isWms'">
													{{scope.row.isWms == 0 ? '否' : '是'}}
												</el-tag>
												<span v-else>
													{{mainData[scope.$index][formOneValue.entityField]}}
												</span>
											</template>
										</el-table-column>
									</el-table>
									<!-- 冷链 -->
									<el-table size="mini" :data="detailData" :height="mxHeight" border
										style="width: 100%" v-if="isShowDetail==true">
										<el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
											<template slot-scope="scope">
												<el-radio v-model="selectedDataIndex" :label="scope.$index" border
													size="mini">
													<i class="el-icon-thumb"></i>
												</el-radio>
											</template>
										</el-table-column>
										<el-table-column
											v-for="(formOneValue,formOneKey) in formDataList[2].jurconfigform"
											:min-width="formOneValue.fieldWeight" :prop="formOneValue.entityField"
											show-overflow-tooltip :label="formOneValue.showField" :key="formOneKey"
											v-if="formOneValue.isShow==1">
											<template slot-scope="scope">
												<span v-if="formOneValue.entityField == 'prodate'">
													<span
														v-if="scope.row[formOneValue.entityField]">{{$common.getLocalTime(scope.row[formOneValue.entityField])}}</span>
												</span>
												<span v-else-if="formOneValue.entityField == 'expidate'">
													<span
														v-if="scope.row[formOneValue.entityField]">{{$common.getLocalTime(scope.row[formOneValue.entityField])}}</span>
												</span>
												<el-tag size="mini" v-else-if="formOneValue.entityField == 'isWms'">
													{{scope.row.isWms == 0 ? '否' : '是'}}
												</el-tag>
												<span v-else>
													{{detailData[scope.$index][formOneValue.entityField]}}
												</span>
											</template>
										</el-table-column>
									</el-table>
								</el-form>
							</div>

							<!-- 冷链信息 -->
							<div v-if="formKey == 1">
								<el-form size="mini" class="baseForm" label-width="150px" :disabled="dataActionBox.actionType == 2"
									:model="sendDataInfo.dewmuColdAdd" ref="dewmuColdAdd" :show-message="false">
									<el-row>
										<el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField"
											:rules="formOneValue.entityField != 'coldRemark' && sendDataInfo.isCold == 1 ? [{required: true, trigger: ['blur', 'change']}] : []"
											v-if="formOneValue.isShow==1"
											v-for="(formOneValue,formOneKey) in formListValue.jurconfigform"
											:key="formOneKey">
											<!-- 系统字段 -->
											<div v-if="formOneValue.isReserved == 0">
												<!-- 到货时间 -->
												<el-date-picker v-if="formOneValue.entityField == 'coldArrtime'"
													:disabled='isShowDetail==false'
													v-model="sendDataInfo.dewmuColdAdd[formOneValue.entityField]"
													type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
													value-format="timestamp">
												</el-date-picker>
												<!-- 起运时间 -->
												<el-date-picker v-else-if="formOneValue.entityField == 'coldStrantime'"
													:disabled='isShowDetail==false'
													v-model="sendDataInfo.dewmuColdAdd[formOneValue.entityField]"
													type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
													value-format="timestamp">
												</el-date-picker>
												<!-- 运输方式 -->
												<el-select filterable
													v-else-if="formOneValue.entityField == 'coldTranmode'"
													:disabled='isShowDetail==false'
													v-model="sendDataInfo.dewmuColdAdd[formOneValue.entityField]">
													<el-option v-for="(values,keys) in dictionariesData.ysfs"
														:key="keys" :label="values.diName" :value="values.diValue">
													</el-option>
												</el-select>
												<!-- 温控方式 -->
												<el-select filterable
													v-else-if="formOneValue.entityField == 'coldTconmode'"
													:disabled='isShowDetail==false'
													v-model="sendDataInfo.dewmuColdAdd[formOneValue.entityField]">
													<el-option v-for="(values,keys) in dictionariesData.wkfs"
														:key="keys" :label="values.diName" :value="values.diValue">
													</el-option>
												</el-select>
												<!-- 备注 -->
												<el-input v-else-if="formOneValue.entityField == 'coldRemark'"
													:disabled='isShowDetail==false' type="textarea"
													v-model.trim="sendDataInfo.dewmuColdAdd[formOneValue.entityField]"
													:maxlength="$store.state.inputLength"></el-input>

												<el-input v-else
													v-model.trim="sendDataInfo.dewmuColdAdd[formOneValue.entityField]"
													:disabled='isShowDetail==false'
													:maxlength="$store.state.inputLength"></el-input>
											</div>
											<!-- 扩展字段 -->
											<div v-if="formOneValue.isReserved == 1">
												<!-- 自填 -->
												<el-input
													v-model.trim="sendDataInfo.dewmuColdAdd[formOneValue.entityField]"
													v-if="formOneValue.operatType == 0"
													:maxlength="$store.state.inputLength"></el-input>
												<!-- 选择数据来源 -->
												<el-input
													v-model.trim="sendDataInfo.dewmuColdAdd[formOneValue.entityField]"
													v-else :maxlength="$store.state.inputLength"></el-input>
											</div>
										</el-form-item>
									</el-row>
								</el-form>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>

				<div style="margin-top: 1rem;text-align: center;">
					<el-button v-if="dataActionBox.actionType!=2" type="primary"
						@click="initActionBox('sendDataInfo','dewmuColdAdd')">取消</el-button>
					<el-button type="primary" @click="sendDataAction('sendDataInfo','dewmuColdAdd')"
						v-if="dataActionBox.actionType==0">保存</el-button>
					<el-button type="primary" @click="sendDataAction('sendDataInfo','dewmuColdAdd')"
						v-if="dataActionBox.actionType==1">保存</el-button>
				</div>
			</div>
		</div>

		<el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
			:modal-append-to-body='true' :append-to-body="true">
			<SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
				@TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
		</el-dialog>
		<!-- 订单提取 -->
		<el-dialog v-if="loadingRecordVisible" :visible.sync="loadingRecordVisible" title="提取销售订单" width="96%"
			:modal-append-to-body='true' :append-to-body="true">
			<loadingRecordListAction :pageShowData="childPageShowData" @loadingRecordReturn="loadingRecordReturn">
			</loadingRecordListAction>
		</el-dialog>

		<el-dialog title="销售记账单列表" v-if="DialogVisible1" :visible.sync="DialogVisible1" :width="seWidth"
			:modal-append-to-body='true' :append-to-body="true">
			<SearchSchemeorderRecord ref="loadingOrderExtract" :loadingOrderExtractData="loadingOrderExtractData"
				@loadingOrderExtractMethods="getExData" />
			<!-- <SearchSchemeorderRecord ref="SearchSchemeorderRecord" :id="searchId" :parentSearchData="parentSearchData1" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="getSelect">确认选择</el-button>
      </span> -->
		</el-dialog>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	import SearchScheme from "../byComponents/SearchScheme.vue";
	import SearchSchemeorderRecord from "../byComponents/SearchSchemeorderRecord.vue";
	export default {
		name: "loadingOrderRecordAction",
		props: ["actionData"],
		//import引入的组件需要注入到对象中才能使用
		components: {
			SearchScheme,
			SearchSchemeorderRecord,
		},
		data() {
			//这里存放数据
			return {
				mxHeight: 400, //明细表格动态高度
				dataActionBox: {
					showStatus: false,
					openMode: "ltr" || "rtl",
					boxTitle: "新增" || "编辑",
					actionType: 0, // 0新增，1修改
				},
				selectedDataIndex: 0,
				sendDataInfo: {
					isCold: 0, //是否冷链(0:否，1:是)
					deliveryName: "", //配送员
					deliveryId: '',
					dewmuColdAdd: { //冷链添加信息
						coldControl: '', //温控设备
						coldLoadingTem: '', //	装载环境温度
						coldRemark: "", //备注说明
						coldStrantem: "", //启运温度s
						coldTem: '', //	预冷温度
						coldTimeLimit: '', //	保温时限
						coldTranmode: "", //运输方式
					},
					isTripartite: 0,
					loId: '',
					loName: '', //物流公司
					logisticsNum: '', //物流单号
					logisticsMoney: '', //物流费用
					driverName: "", //司机
					vmLicensecode: "", //车牌号
					transportDetailAddList: [], //装车单明细添加信息
				},
				mainData: [], //普通明细
				detailData: [], //冷链明细
				showTabs: "",
				formDataList: [],
				dictionariesData: {},
				DialogVisible: false, //检索信息
				seId: "",
				seWidth: "",
				seTitle: "",
				searchType: "",
				parentSearchData: {
					opmDriver: 0,
					opmBuyer: '',
				},
				loadingOrderExtractData: {
					coldFlag: 0,
				},
				childPageShowData: [], //子组件的表格头
				loadingRecordVisible: false,
				isLoaded: false,
				isShowDetail: false,
				DialogVisible1: false,
				searchId: "",
				parentSearchData1: {
					cmId: "",
					coId: "",
					opmId: "",
					salesId: "",
					depId: "",
				},
				detailSelectList: [],
				seIndex: 0,
				seType: '',
				sField: ''
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			changeOrder(val) {
				if (val == 0) {
					this.isShowDetail = false
				} else {
					this.isShowDetail = true
				}
				this.loadingOrderExtractData.coldFlag = val
			},
			//检索Id, 索引(表格中), 标识
			openSearch(sId, index, type, sField) {
				this.DialogVisible = true;
				this.seId = sId;
				this.seIndex = index;
				this.seType = type;
				this.sField = sField;
				this.parentSearchData[type] = this.sendDataInfo[type]
				this.parentSearchData.opmDriver = type == 'driverName' ? 1 : ''
				this.parentSearchData.opmDistributor = type == 'driverName' ? '' : 1
			},
			// 赋值字段
			paramValue(val) {
				let arr = this.sField.split(',')
				arr.forEach(item => {
					this.sendDataInfo[item] = val[item]
				})
			},
			// 获取 提取单数据
			async getExData(res) {
				let val = JSON.parse(JSON.stringify(res));
				console.log("提取", val);
				if (!this.isShowDetail) { //普通--wobkemId
					this.mainData = [].concat(val.mainData)
					console.log('main', this.mainData)
					// this.mainData.splice(1,0)
				} else { //冷链--wobkedId
					this.detailData = [].concat(val.detailData)
					console.log('detailData', this.detailData)
					// this.detailData.splice(1,0)
				}
				this.DialogVisible1 = false;
			},
			async extract(sendDataInfo) {
				let flag = true
				if (this.sendDataInfo.isTripartite == 0) {
					if (this.sendDataInfo.vmLicensecode == '' || this.sendDataInfo.deliveryName == '' || this.sendDataInfo
						.driverName == '') {
						flag = false
						return this.$message({
							message: "请完善必填信息",
							type: "error",
						});
					}
				} else if (this.sendDataInfo.isTripartite == 1) {
					if (this.sendDataInfo.loName == '' || this.sendDataInfo.logisticsNum == '' || this.sendDataInfo
						.logisticsMoney == '') {
						flag = false
						return this.$message({
							message: "请完善必填信息",
							type: "error",
						});
					}
				}
				if (flag) this.DialogVisible1 = true;
			},
			getSelect() {
				var mx = this.$refs.SearchSchemeorderRecord.multipleSelection;
				if (this.tableType == 0) {
					this.sendDataInfo.suSettleInvoiceVos = mx;
					this.sendDataInfo.suSettleInvoiceVos.forEach((item) => {
						this.$set(item, "settleMoney", 0);
					});
					this.sendDataInfo.totalCount =
						this.sendDataInfo.suSettleInvoiceVos.length;
				} else if (this.tableType == 1) {
					this.sendDataInfo.suSettleInvoiceDetailVos = mx;
					this.sendDataInfo.suSettleInvoiceDetailVos.forEach((item) => {
						this.$set(item, "settleMoney", 0);
					});
					this.sendDataInfo.totalCount =
						this.sendDataInfo.suSettleInvoiceDetailVos.length;
				}
				this.DialogVisible1 = false;
				this.sendDataInfo.totalMoney = 0;
			},
			//装车单据子组件
			loadingRecordReturn(str) {
				this.sendDataInfo.wobkemId = str;
				this.loadingRecordVisible = false;
			},

			//提取返回
			changeInputModel(val) {
				console.log("返回", val);
				if (val != "" || val != undefined) {
					this.DialogVisible = false;
					this.paramValue(val)
					if (this.seType == 'deliveryName') {
						this.sendDataInfo.deliveryName = val.opmName
						this.sendDataInfo.deliveryId = val.opmId
					} else if (this.seType == 'loName') {
						this.sendDataInfo.loName = val.companyName
						this.sendDataInfo.loId = val.loId
					} else if (this.seType == 'driverName') {
						this.sendDataInfo.driverName = val.opmName
						this.sendDataInfo.driverId = val.opmId
					}
				} else {
					this.$message({
						message: "检索信息失败",
						type: "warning",
					});
				}
			},
			getSeWidth(e) {
				this.seWidth = e + "%";
			},
			getSearchName(e) {
				this.seTitle = e;
			},
			//确认新增
			sendDataAction(formName1, formName2) {
				this.sendDataInfo.transportDetailAddList = [];
				if (this.sendDataInfo.isCold == 0) { //普通--wobkemId
					this.mainData.forEach((item) => {
						this.sendDataInfo.transportDetailAddList.push(item.wobkemId);
					});
				} else if (this.sendDataInfo.isCold == 1) { //冷链--wobkedId
					this.detailData.forEach((item) => {
						console.log(item);
						this.sendDataInfo.transportDetailAddList.push(item.wobkedId);
					});
				}
				let flag = true
				if (this.sendDataInfo.isTripartite == 0) {
					if (this.sendDataInfo.vmLicensecode == '' || this.sendDataInfo.deliveryName == '' || this.sendDataInfo
						.driverName == '') {
						flag = false
						return this.$message({
							message: "请完善装车单必填信息",
							type: "error",
						});
					}
				} else if (this.sendDataInfo.isTripartite == 1) {
					if (this.sendDataInfo.loName == '' || this.sendDataInfo.logisticsNum == '' || this.sendDataInfo
						.logisticsMoney == '') {
						flag = false
						return this.$message({
							message: "请完善装车单必填信息",
							type: "error",
						});
					}
				}
				if (flag) {
					if (this.sendDataInfo.isCold == 0) {
						this.sub()
					} else {
						this.$refs[formName2][0].validate((valid) => {
							if (valid) {
								this.sub()
							} else {
								this.$message({
									message: "请完善冷链信息的必填信息",
									type: "error",
								});
								return false;
							}
						});
					}
				}
				
			},
			async sub() {
				var responseData;
				if (this.dataActionBox.actionType == 0) {
					responseData = await this.$http.transportdocAdd(this.sendDataInfo);
				} else {
					responseData = await this.$http.setTransportdocAdd(this.sendDataInfo);
				}
				if (responseData.status == 200) {
					this.init();
					this.$refs["sendDataInfo"][0].resetFields();
					this.$refs["dewmuColdAdd"][0].resetFields();
					this.$message({
						message: "操作成功",
						type: "success",
					});
					this.$emit("drawerCancel");
					// this.dataActionBox.showStatus = false
					// this.$parent.getDataList()
				} else {
					this.$message({
						message: responseData.message,
						type: "error",
					});
				}
			},
			//取消
			initActionBox(formName1, formName2) {
				var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
				this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$emit("drawerCancel");
						this.init();
						this.$refs[formName1][0].resetFields();
						this.$refs[formName2][0].resetFields();
					})
					.catch(() => {});
			},
			//初始化
			init() {
				for (let key in this.sendDataInfo) {
					if (key == "dewmuColdAdd") {
						for (let sonOne in this.sendDataInfo[key]) {
							if (sonOne == "coldArrtime" || sonOne == "coldStrantime") {
								this.sendDataInfo[key][sonOne] = this.$moment().valueOf();
							} else {
								this.sendDataInfo[key][sonOne] = "";
							}
						}
					} else if (key == 'isCold' || key == 'isTripartite') {
						this.sendDataInfo[key] = 0
					} else {
						this.sendDataInfo[key] = "";
					}
				}
			},
			//父级传入
			openBox(cate, formData, oldData = "") {
				this.showTabs = formData[0].jciName;
				this.formDataList = formData;
				this.init();
				if (cate == 0) {
					this.dataActionBox.boxTitle = "新增信息";
					this.dataActionBox.openMode = "ltr";
				} else if (cate == 1) {
					this.dataActionBox.boxTitle = "编辑信息";
					this.dataActionBox.openMode = "rtl";
					var dataInfo = JSON.parse(JSON.stringify(oldData));
					for (let key in dataInfo) {
						this.sendDataInfo[key] = dataInfo[key];
					}
				} else {
					this.dataActionBox.boxTitle = "查看信息";
					var dataInfo = JSON.parse(JSON.stringify(oldData));
					for (let key in dataInfo) {
						this.sendDataInfo[key] = dataInfo[key];
					}
					if (this.sendDataInfo.wobkeInfoList) this.mainData = this.sendDataInfo.wobkeInfoList
					if (this.sendDataInfo.wobkedetailInfoList) this.detailData = this.sendDataInfo.wobkedetailInfoList
					if (dataInfo.dewmuCold) this.sendDataInfo.dewmuColdAdd = dataInfo.dewmuCold
					if (dataInfo.isCold == 0) {
						this.isShowDetail = false
					} else {
						this.isShowDetail = true
					}
				}
				this.dataActionBox.actionType = cate;
				this.dataActionBox.showStatus = true;
				this.childPageShowData = [this.formDataList[3], this.formDataList[2]]; //子组件的表格头

			},

			// 获取字典数据
			async getPartDictionariesData() {
				let responseData = await this.$http.getPartDictionariesData({
					ids: [20, 21, 27, 28],
				});
				if (responseData.status == 200) {
					this.dictionariesData = responseData.result;
				} else {
					this.$message({
						message: responseData.message,
						type: "error",
					});
				}
			},
			//换行提示
			lineMessageBox(data) {
				let txtArr = data.message.split("<br/>");
				let newArr = [];
				const h = this.$createElement;
				for (const i in txtArr) {
					newArr.push(h("p", null, txtArr[i]));
				}
				this.$alert(h("div", null, newArr), "提示", {
					confirmButtonText: "确定",
					callback: (action) => {},
				});
			},


		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			this.$nextTick(() => {
				var params = this.actionData;
				this.openBox(params.cate, params.formData, params.oldData);
				this.isLoaded = true;
			});
			this.getPartDictionariesData();
		},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
},
		beforeCreate() {}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {
			// this.$nextTick(() => {
			//     var sheight = this.$refs.sendDataInfo[0].$el.clientHeight;
			//     if (this.dataActionBox.actionType != 2) {
			//       this.mxHeight = document.documentElement.clientHeight - sheight - 270;
			//     } else {
			//       this.mxHeight = document.documentElement.clientHeight - sheight - 260;
			//     }
			//   });
		}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>

<style scoped>
	.table_button_box {
		height: 200px;
		background-color: red;
	}

	.table_content_box {
		/* height: 500px !important; */
		overflow-y: auto;
	}

	.el-row {
		display: flex;
		flex-wrap: wrap;
		padding-right: 20px;
	}

	.el-drawer {
		outline: none;
	}

	.v-modal {
		position: static !important;
		width: 100%;
		height: 100%;
		background: transparent;
	}
</style>